import Requester from '@cobliteam/api-lib/src/request/Requester';
import Environment from '@cobliteam/react-environments';
import { MastraClient } from '@mastra/client-js';

const environment = Environment.getInstance().getEnvironment();
const requester = new Requester({ host: environment.mastraApi });

export const MASTRA_BASE_URL = environment.mastraApi;

export const controller = new AbortController();

export const mastraClient = async () => {
  const accessToken = await requester.getValidToken();
  return new MastraClient({
    baseUrl: MASTRA_BASE_URL,
    abortSignal: controller.signal,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

export interface MastraFetchOptions extends Omit<RequestInit, 'body'> {
  body?: Record<string, any>;
  stream?: boolean;
}

export const mastraFetch = async (path: string, options: MastraFetchOptions = {}): Promise<Response> => {
  const accessToken = await requester.getValidToken();
  const { body, stream: _stream, ...rest } = options;

  const response = await fetch(`${MASTRA_BASE_URL}${path}`, {
    ...rest,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...(rest.headers as Record<string, string>),
    },
    signal: controller.signal,
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`AI-API request failed (${response.status}): ${errorText}`);
  }

  return response;
};

export default mastraClient;
